var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-layout',{staticClass:"ma-4"},[_vm._v("\n    "+_vm._s(_vm.$t('document.download.message'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }